import { Navigate, useSearchParams } from 'react-router-dom'

/**
 * Resolves the redirect target for the mobile `/samples/needs-review` route.
 *
 * Exported separately so it can be unit-tested without rendering — this repo's
 * vitest setup runs in a `node` environment and does not include
 * `@testing-library/react` or a DOM, so component-level tests aren't viable.
 *
 * @param rawId Value of the `sample_request_id` query param (or null).
 * @returns Absolute path to navigate to.
 */
export function resolveNeedsReviewRedirect(rawId: string | null): string {
  if (rawId && /^\d+$/.test(rawId)) {
    return `/samples/${rawId}`
  }
  return '/samples?tab=needs_review'
}

/**
 * Email link `/samples/needs-review/?sample_request_id=X&mode=review`
 * is the desktop entry point. On mobile we redirect:
 *   - to /samples/:id when a numeric id is present (the typical email-link case)
 *   - to /samples?tab=needs_review when no id (someone bookmarked the desktop URL)
 *
 * See spec: docs/superpowers/specs/2026-05-15-fir-7294-mobile-approve-broker-samples-design.md
 */
export function MobileSamplesNeedsReviewRedirect() {
  const [params] = useSearchParams()
  const target = resolveNeedsReviewRedirect(params.get('sample_request_id'))
  return <Navigate to={target} replace />
}
